import {FC, ReactNode, useEffect, useMemo, useState} from 'react'
import { v4 as uuidv4 } from 'uuid';
import {CRMColumnDef, MasterDataTableTanstack} from '../../../components/DataTable/MasterDataTableTanstack'
import {useIntl} from 'react-intl'
import useUser from '../../../hooks/User'
import {CellContext, ColumnDef} from '@tanstack/react-table'
import {IconButton, Menu, MenuItem} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import {useDataTableStore} from '../../../stores/DataTableStore'
import useAccessToken from '../../../hooks/AccessToken'
import Swal from 'sweetalert2'
import {InvoiceMultiPageSetting} from '../../../interfaces/Invoices'
import {DeleteInvoice} from '../../../components/Invoices/DeleteInvoice'
import moment from 'moment-timezone'
import axios from 'axios'
import useSWR, { mutate } from 'swr'
import {useSettingsStore} from '../../../stores/SettingsStore'
import {convertWhatsappToHtmlDiv, isColorDarkFromHex} from '../../../functions/general'
import {AddInvoice} from '../../../components/Invoices/AddInvoice'
import {UpdateInvoice} from '../../../components/Invoices/UpdateInvoice'
import DescriptionIcon from '@mui/icons-material/Description';
import useDynamicTab from '../../../hooks/useDynamicTab'
// import "moment/locale/en-gb"; // English (United Kingdom)
// import "moment/locale/en-ca"; // English (Canada)
// import "moment/locale/en-au"; // English (Australia)
// import "moment/locale/en-nz"; // English (New Zealand)
// import "moment/locale/en-in"; // English (India)
import 'moment/locale/fr' // French (default)
// import "moment/locale/fr-ca"; // French (Canada)
// import "moment/locale/fr-ch"; // French (Switzerland)
import 'moment/locale/de' // German (default)
// import "moment/locale/de-at"; // German (Austria)
// import "moment/locale/de-ch"; // German (Switzerland)
import 'moment/locale/es' // Spanish (default)
// import "moment/locale/es-mx"; // Spanish (Mexico)
import 'moment/locale/it' // Italian (default)
// import "moment/locale/it-ch"; // Italian (Switzerland)
import 'moment/locale/ja' // Japanese
import 'moment/locale/ko' // Korean
import 'moment/locale/zh-cn' // Chinese (Simplified)
import 'moment/locale/zh-tw' // Chinese (Traditional)
import 'moment/locale/ru' // Russian
import 'moment/locale/ar' // Arabic
import 'moment/locale/id' // Indonesian
import {InvoiceAttachments, InvoiceRenderContext} from '../../../components/Pipelines/Logs/InvoiceAttachments'
import { Pipeline } from '../../../interfaces'
import { RecentChatHistoryPipeline } from '../../../interfaces/Chat/RecentChatHistory'
import { useCustomeStore } from '../../../stores/CustomeStore'
import { DateRangePicker } from 'rsuite'
import useCalendarLocale from '../../../hooks/CalendarLocale'
import { endOfYear, startOfMonth, startOfYear, subDays } from 'date-fns'
import usePredefinedRanges from '../../../hooks/PredefinedRanges'
import useCheckIsMobile from '../../../hooks/useCheckIsMobile'
import { Button } from 'react-bootstrap'
import { DetailPipeline } from '../../../components/Pipelines/DetailPipeline'
import Select from 'react-select'
import { FilterInvoices } from '../../../components/Invoices/List-Invoice/FilterInvoice'
import { regenerateInvoiceMaspion } from '../../../api/InvoicesCRUD'
import { getDetailPipeline } from '../../../api/PipelineCRUD';
import useModalEffect from '../../../hooks/useModalEffect';
import { LoadingInvoiceContent } from '../../../components/Invoices/InvoiceComponentParts';
import { usePipelineStore } from '../../../stores/PipelineStore';
import { getTemplateSettingPipeline } from '../../../api/SettingCRUD';

const today = new Date()
const tableKey = 'list/invoices'
const table_URL = 'invoices/generated/list'

const MasterListInvoices: FC = () => {
  const API_URL = process.env.REACT_APP_API_URL
  
  const intl = useIntl()
  const currentLocale = intl.locale
  moment.locale(currentLocale === 'id' ? 'id' : 'en'); 
  useDynamicTab({title: `${intl.formatMessage({id: 'MENU.INVOICES'})} | CRM WooBlazz`})

  const user = useUser()
  const token = useAccessToken()

  const { settings } = useSettingsStore()
	const { isMobile } = useCheckIsMobile()
	const { companyId, roleId, keyCustomfield } = useCustomeStore()
  const { tablesData, setTableColumnVisibility, tableColumnVisibility, setTableColumns, tableColumns, setIsLoadingTable, isFullyLoaded, selectedFilters, filteredTablesData } = useDataTableStore()
  const { selectMultiPipeline, setSelectMultiPipeline } = usePipelineStore()

	const calendarLocale = useCalendarLocale();
	const predefinedRanges = usePredefinedRanges();
  const [typeDate, setTypeDate] = useState("DATE_CREATED");
	const [startDate, setStartDate] = useState<Date>(user.data.company_id === companyId.hom ? subDays(today, 1) : user.data.company_id === companyId.happyPlay ? startOfMonth(today) : startOfYear(today));
	const [endDate, setEndDate] = useState<Date>(user.data.company_id === companyId.tkd ? endOfYear(today) : today);

  const [isFetchingLoading, setIsFetchingLoading] = useState<boolean>(false)
  const [manageColumns, setManageColumns] = useState<CRMColumnDef<any>[]>([])
	
  // const [pipeline, setPipeline] = useState<Pipeline>();
  const [invoice, setInvoice] = useState<InvoiceMultiPageSetting[]>()
  const [showInvoiceModal, setShowInvoiceModal] = useState<boolean>(false)
  const [showDetailPipelineModal, setShowDetailPipelineModal] = useState<boolean>(false)
  const [invoiceContext, setInvoiceContext] = useState<InvoiceRenderContext>('preview')
  const [selectPipeline, setSelectPipeline] = useState<Pipeline>()
  const [selectInvoice, setSelectInvoice] = useState<InvoiceMultiPageSetting>()

  const optionsTypeDate = [
    { value: 'DATE_CREATED', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_CREATED" }) },
    // { value: 'DATE_STARTED', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_STARTED" }) },
    // { value: 'DATE_ENDED', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_ENDED" }) },
  ]

  const handleRegenerateDataInvoice = async () => {
    setIsFetchingLoading(true)
    try {
      const { data } = await regenerateInvoiceMaspion(token)
      if (data.success) {
        // console.log('data', data);
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ALERT.TITLE.SUCCESS'}),
          text: intl.formatMessage({id: 'INVOICE.ALERT.REGENERATE_DATA'}, {title:moment().format('MMMM YYYY')}), //{title:settings.pipeline_title}
          heightAuto: false,
          confirmButtonText: 'Ok',
        })
        mutate(`${API_URL}${table_URL}`)
      }
    } catch (error:any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    } finally {
      setIsFetchingLoading(false)
    }
  }

  useModalEffect({
    showModal: showDetailPipelineModal,
    setShowModal: setShowDetailPipelineModal,
    modalId: `detail-pipeline-modal`
  })

  const onRowClicked = async (row: any, event: React.MouseEvent<HTMLTableRowElement>) => {
    // event.stopPropagation()

    if(row.lead.isDeleted) {
      return Swal.fire({
        icon: 'info',
        title: intl.formatMessage({id: 'INVOICE.ALERT.CANNOT_PROCEED'}),
        text: intl.formatMessage({id: 'INVOICE.ALERT.DELETED_PIPELINE'}, {pipeline:settings.pipeline_title, title:row.lead.template.name}), //{title:settings.pipeline_title}
        heightAuto: false,
        confirmButtonText: 'Ok',
      })
    }
    setIsFetchingLoading(true)
    try {
      const {data: dataPipeline} = await getTemplateSettingPipeline(token, row.lead.template.id)
      // console.log('dataPipeline',dataPipeline)
      if(dataPipeline.success) {
        setSelectMultiPipeline(dataPipeline.data)
      }

      const {data} = await getDetailPipeline(row.lead.id, token) 
      // console.log('data',data)
      if(data.success) {
        setSelectPipeline(data.data)
        setShowDetailPipelineModal(true);
      }
    } catch (error:any) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: error.response.data.message || 'Error',
        confirmButtonText: 'Ok',
      })
    } finally {
      setIsFetchingLoading(false)
    }
  };

  const handleInvoiceModalClose = (isSkipAlert: boolean = false) => {
    // setIsBack(false)
    setShowInvoiceModal(false)
    // setStepForm(0)
    // if (!isSubmit) {
    //   setItems([])
    //   setItem(null)
    //   // formik.resetForm()
    //   setColumn([])
    // }
  }

  // -------------------------------------------- Data Table --------------------------------------------

  const columns = useMemo<ColumnDef<any>[]>(() => [
    {
      id: uuidv4(),
      header: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.DATE_CREATED'}),
      meta:{
        styleHeader:{
          width: '100px',
          // textAlign: 'center'
        },
        styleBody: {
          width: '100px',
          // textAlign: 'center'
        }
      },
      // accessorFn: (row) => {
      //   return row.createdAt ? moment(row.createdAt).format('DD MMM YYYY HH:mm') : '-'
      // },
      accessorKey: 'createdAt',
      cell: (props: CellContext<any, unknown>) => {
        const row = props.row.original
        return (
          <div>
            {row.createdAt ? moment(row.createdAt).format('DD MMM YYYY HH:mm:ss') : '-'}
          </div>
        )
      },
    },
    ...(user?.data.company_id === companyId.maspionSquare ? [{
      id: uuidv4(),
      header: 'Customer Type',
      meta:{
        styleHeader:{
          width: '160px',
          // textAlign: 'center'
        },
        styleBody: {
          width: '160px',
          textAlign: 'center'
        }
      },
      cell: (props: CellContext<any, unknown>) => {
        const row = props.row.original
        // console.log("row.merchant_custom_fields['b4f3e5fb-6c49-4b1a-8d34-3c5f4e3c9d5b']", row.lead.merchant.customFields['b4f3e5fb-6c49-4b1a-8d34-3c5f4e3c9d5b'])
        return (
          <div>
            {row.lead.merchant.customFields['b4f3e5fb-6c49-4b1a-8d34-3c5f4e3c9d5b'] || "-"}
          </div>
        )
      },
    }]:[]),
    {
      id: uuidv4(),
      header: intl.formatMessage({id: 'INVOICE.LABEL.NAME_DYNAMIC'}, {title:settings.merchant_title}),
      meta:{
        styleHeader:{
          width: '200px',
          // textAlign: 'center'
        },
        styleBody: {
          width: '200px',
          // textAlign: 'center'
        }
      },
			accessorKey: 'lead.merchant.name'
    },
    {
      id: uuidv4(),
      header: intl.formatMessage({id: 'INVOICE.LABEL.NAME_SETTING'}),
      accessorKey: 'setting.name',
      meta:{
        styleHeader:{
          width: '200px',
          // textAlign: 'center'
        },
        styleBody: {
          width: '200px',
          // textAlign: 'center'
        }
      },
      cell: (props: CellContext<any, unknown>) => {
        const row = props.row.original
        return (
          <div
            style={{
              maxWidth: '400px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 4,
              padding: '0',
            }}
          >
            {row.setting.name}
          </div>
        )
      },
    },
    {
      id: uuidv4(),
      header: `${intl.formatMessage({id: 'FORM.LABEL.TEMPLATE_NAME'})} / ${intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.PROGRESS'})}`,
      // accessorKey: 'progress.name',
      accessorFn: (row) => `${row.lead.template.name} / ${row.progress.name}`,
      // meta:{
      //   styleHeader:{
      //     width: '260px',
      //     // textAlign: 'center'
      //   },
      //   styleBody: {
      //     width: '260px',
      //     // textAlign: 'center'
      //   }
      // },
      cell: (props: CellContext<any, unknown>) => {
        const row = props.row.original
        return (
          <div className='d-flex flex-column gap-2'>
            <span className='fw-bold'>{row.lead.template.name}</span>
            <span style={{ borderLeft: '4px solid gray', paddingLeft: '8px' }}>
              {`${row.progress.name}`}
            </span>
          </div>
        )
      },
    },
    {
      id: uuidv4(),
      header: intl.formatMessage({id: 'INVOICE.COLUMN.DATE_SENT'}),
      meta:{
        styleHeader:{
          width: '80px',
          // textAlign: 'center'
        },
        styleBody: {
          width: '80px',
          textAlign: 'center'
        }
      },
      // accessorFn: (row) => {
      //   return row.sentToScheduleAt ? moment(row.sentToScheduleAt).format('DD MMM YYYY HH:mm') : '-'
      // },
      accessorKey: 'sentToScheduleAt',
      cell: (props: CellContext<any, unknown>) => {
        const row = props.row.original
        return (
          <div>
            {row.sentToScheduleAt ? moment(row.sentToScheduleAt).format('DD MMM YYYY HH:mm:ss') : '-'}
          </div>
        )
      },
    },
    {
      id: uuidv4(),
      header: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.ACTION'}),
      cell: (props: CellContext<any, unknown>) => {
        const row: any = props.row.original
        return (
          <>
            <button
              type='button'
              data-prevent-onRowClicked // prod bug
              className='d-flex items-center gap-2 btn btn-primary btn-sm'
              style={{ zIndex:'100' }}
              onClick={(e) => {
                e.preventDefault()
                setShowInvoiceModal(true)
                setInvoiceContext('resend-whatsapp')
                setSelectPipeline(row)
                setSelectInvoice(row)
              }}
            >
              Preview
            </button>
            {/* <Button 
                        variant="outline-info"
                        onClick={()=>{
                            setShowInvoiceModal(true); 
                            setInvoiceContext('download')
                            // setInvoice(row)
                        }}
                        >
                        Download
                    </Button> */}
          </>
        )
      },
    },
  ], [user?.data.company_id, settings.merchant_title, intl]);

  useEffect(() => {
    setManageColumns(columns)
    setTableColumnVisibility(tableKey, (prev) => {
      const newState = { ...prev };
      columns.forEach((column) => {
        newState[column.id ?? '???'] = true;
      });
      return newState;
    });
    setTableColumns(tableKey, columns);
  }, [])

  const actions: ReactNode[] = [];
  if (user?.data.company_id === companyId.maspionSquare) {
    actions.push(
      <Button
        variant="success"
        type='button'
        size="sm"
        className='d-flex items-center gap-2 fs-6'
        onClick={() => {
          handleRegenerateDataInvoice()
        }}
      >
        <DescriptionIcon /> Regenerate
      </Button>
    );
  }
  actions.push(
    <FilterInvoices 
      tableKey={tableKey} 
      manageColumns={manageColumns} 
      setManageColumns={setManageColumns}
      // onVisibilityChange={handleVisibilityChange}
    />
  )

  return (
    <div className='position-relative'>
      {isFetchingLoading && 
        <div className='position-absolute top-50 start-50 translate-middle w-100 h-100' style={{ zIndex: 9999, backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>
          <LoadingInvoiceContent spinnerType='border' style={{ height: '90%' }} size={undefined} qty={1} />
        </div>
      } 
			<div className="row justify-content-between mb-3">
				<div className='col-sm-3 col-lg-4 col-xl-5' style={{ alignSelf: 'center' }}>
					<ol className='breadcrumb text-muted fs-6 fw-bold'>
						{/* <li className='breadcrumb-item text-muted'>{intl.formatMessage({id: 'MENU.STUDIO'})}</li> */}
						<li className='breadcrumb-item text-dark'>{intl.formatMessage({ id: 'MENU.INVOICES' })}</li>
					</ol>
				</div>

				<div className="col-lg-8 col-sm-9 col-xl-7">
					<div className="d-flex float-end px-3">
						{/* <Select
							styles={{
								control: (baseStyles, state) => ({
									...baseStyles,
									border: "none", // Menghilangkan simbol garis
									backgroundColor: "none",
									maxWidth: "200px"
								}),
								option: (baseStyles, { isSelected, isFocused }) => ({
									...baseStyles,
									backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
									cursor: 'pointer'
								}),
							}}
							theme={(theme) => ({
								...theme,
								colors: {
									...theme.colors,
									primary: 'none',
								},
							})}
							onChange={(data: any) => { setTypeDate(data.value) }}
							value={optionsTypeDate.find(option => option.value === typeDate)}
							className='react-select-styled z-index-3'
							classNamePrefix='react-select'
							options={optionsTypeDate}
							placeholder='Select an option'
							isSearchable={false}
						/> */}

						<DateRangePicker
							style={{ width: "250px" }}
							cleanable={false}
							character=" - "
							format="dd MMM yyyy"
							locale={calendarLocale}
							value={[startDate, endDate]}
							ranges={predefinedRanges}
							placement="bottomEnd"
							onChange={(value) => {
								if (value && value.length === 2) {
									setStartDate(value[0]);
									setEndDate(value[1]);
								}
							}}
							showOneCalendar={isMobile}
							// disabled={loading}
							isoWeek={true}
							editable={false}
						/>

						{
							isFullyLoaded ?
								<div onClick={() => {
									mutate(`${API_URL}${table_URL}`)
									// setFetchCounter(fetchCounter + 1)
								}} className="btn btn-light btn-sm ms-2">
									<i className="p-0 fa-sync-alt fas"></i>
								</div> :
								<div className="ms-2 my-auto spinner-border spinner-border-sm" role="status">
								</div>
						}
					</div>
				</div>
			</div>

      <MasterDataTableTanstack
        tableKey={tableKey}
        tableColumns={columns}
        actions={actions}
        apiURL={table_URL}
				dateStart={moment(startDate).startOf('day').toISOString()}
				dateEnd={moment(endDate).endOf('day').toISOString()}
        autoReload={false}
        onRowClicked={(row, e) => onRowClicked(row, e)}
      />

      {settings.feature_invoice && selectPipeline && selectInvoice && (
        <InvoiceAttachments
          lead={selectPipeline}
          invoice={selectInvoice}
          context={invoiceContext}
          routerContext='list-invoice'
          showInvoiceModal={showInvoiceModal}
          handleInvoiceModalClose={(isSkipAlert) => {
            handleInvoiceModalClose(isSkipAlert)
        }} 
        />
      )}
      {
        showDetailPipelineModal && selectPipeline && <DetailPipeline data={selectPipeline} />
      }
    </div>
  )
}

export default MasterListInvoices
